import type { TTaskListItem, TTaskTableSection } from '@modules/projects/tasks/types';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import StageSectionHeader from './components/StageSectionHeader';
import { groupTasksByStage } from './helpers';
import { EStageStatus, type TStage } from './types';

export const getStageTableSections = (
  projectId: string,
  stages: TStage[],
  tasks: TTaskListItem[]
): TTaskTableSection[] =>
  groupTasksByStage(stages, tasks).map(({ stage, tasks: sectionTasks }) => ({
    // A status change resets the section to its default expansion: only the current stage starts open.
    id: stage ? `stage-${stage.index}-${stage.status}` : 'other',
    label: stage?.title ?? `Other ${TERMINOLOGY.task.lowerPlural}`,
    header: <StageSectionHeader projectId={projectId} stage={stage} count={sectionTasks.length} />,
    tasks: sectionTasks,
    defaultExpanded: stage?.status === EStageStatus.CURRENT,
  }));
